import { Block } from '@xprog/prensa'

type SlotMainColumnVariants = 'oneColumn' | 'twoColumns'

type SlotMainColumnProps = {
  children?: any
  variant: SlotMainColumnVariants
}

const SlotMainColumn: React.FC<SlotMainColumnProps> = (props) => {
  if (props.variant === 'oneColumn') {
    return (
      <Block
        className='SlotContainer'
        css={{
          '.MainContent': {
            align: ['column', 'center', 'top'],
            width: '100%'
          },
          width: '100%',
          '@lg': {
            align: ['row', 'center', 'top'],
            // mt: '$12'
          }
        }}
      >
        {props.children}
      </Block>
    )
  }
  return (
    <Block
      className='SlotContainer'
      css={{
        mt: '$4',
        width: '100%',
        '.MainContent': {
          align: ['column', 'center', 'top'],
          width: '100%',
        },
        '.SideContent': {
          align: ['column', 'center', 'top'],
          width: '100%',
        },
        '@lg': {
          align: ['row', 'center', 'top'],
          alignItems: 'stretch',
          mt: '$4',
          '.MainContent': {
            maxWidth: 'calc(1280px - 324px)',
            width: 'calc(calc(100% - 300px) - $8)'
          },
          '.SideContent': {
            ml: '$6',
            width: '300px'
          }
        }
      }}
    >
      {props.children}
    </Block>
  )
}

export default SlotMainColumn
